<script lang="ts">
    import { onMount } from 'svelte';

    import { MultiSelectWide } from '../components/telematics/components/MultiSelectWide/MultiSelectWide';
    import type { Entry, EntryId } from '../components/telematics/components/MultiSelectWide/types';

    export let loadOptions: (searchQuery: string) => Promise<Entry[]>;
    export let selectedIds: EntryId[] = [];
    export let onChange: (selectedIds: EntryId[]) => void = () => {};
    export let disabled: boolean = false;
    export let minAllowedSelectedItems = 1;
    export let maxAllowedSelectedItems: number | undefined = undefined;
    export let forceConvertIdToString: boolean = false;
    export let initialQuery: string = '';

    let root: HTMLElement;

    onMount(() => {
        // Initialize MultiSelectWide with loadOptions - it will handle async loading internally
        new MultiSelectWide(
            {
                parentRoot: root,
                multiple: true,
                availableEntries: [], // Empty initially, loadOptions will populate
                selectedIds,
                minAllowedSelectedItems,
                maxAllowedSelectedItems,
                forceConvertIdToString,
                initialQuery,
                loadOptions, // Pass loadOptions directly to MultiSelectWide
            },
            {
                onChange: newSelectedIds => {
                    console.log('selectedIds:', newSelectedIds);
                    onChange(newSelectedIds);
                },
            }
        );
    });
</script>

<div bind:this={root} class:disabled />

<style>
    .disabled {
        pointer-events: none;
        opacity: 0.5;
    }
</style>
